import { apiClient } from '../lib/api';

/**
 * Serviço para gerenciar o onboarding do usuário
 */
export const OnboardingService = {
  /**
   * Obtém o status atual do onboarding
   * @returns {Promise<Object>} Status do onboarding
   */
  async getStatus() {
    const response = await apiClient.get('/api/onboarding/status');
    return response.data;
  },

  /**
   * Salva as respostas de uma etapa específica
   * @param {number} step - Número da etapa (1-7)
   * @param {Object} responses - Respostas da etapa
   * @returns {Promise<Object>} Status atualizado
   */
  async saveStep(step, responses) {
    const response = await apiClient.post('/api/onboarding/step', {
      step,
      responses
    });
    return response.data;
  },

  /**
   * Marca o onboarding como completo
   * @returns {Promise<Object>} Status final
   */
  async complete() {
    const response = await apiClient.post('/api/onboarding/complete');
    return response.data;
  },

  /**
   * Pula o onboarding (marca como completo sem respostas)
   * @returns {Promise<Object>} Status
   */
  async skip() {
    const response = await apiClient.post('/api/onboarding/skip');
    return response.data;
  },

  /**
   * Reseta o onboarding para refazer
   * @returns {Promise<Object>} Status resetado
   */
  async reset() {
    const response = await apiClient.post('/api/onboarding/reset');
    return response.data;
  },

  /**
   * Obtém as preferências do usuário baseado no onboarding
   * @returns {Promise<Object>} Preferências extraídas
   */
  async getPreferences() {
    const response = await apiClient.get('/api/onboarding/preferences');
    return response.data;
  },

  /**
   * Verifica se o usuário precisa fazer onboarding
   * @returns {Promise<boolean>} True se precisa fazer onboarding
   */
  async needsOnboarding() {
    try {
      const status = await this.getStatus();
      return !status.completed;
    } catch (error) {
      console.error('Erro ao verificar status do onboarding:', error);
      return false;
    }
  }
};

export default OnboardingService;